import { Panel } from "../../../../../../components/ui/Panel";
import I18n from "../../../../../../core/localization/I18n";
import ModalContext from "../../../../../../core/modalZ/context/ModalContext";
import { Animations } from "../../../../../../core/util/Animations";
import { CopyProject } from "./CopyProject_view";

export const SHOW_COPY_PROJECT_MODAL = () => {
  ModalContext.show({
    showClose: true,
    title: <h1 className="mt-6">{I18n.t("phrases.copyProject")}</h1>,
    content: <CopyProject />,
    componentProps: {
      wrapHeight: "default",
      wrapWidth: "medium",
      position: "middle",
      panelProps: {
        background: Panel.PanelBackgrounds.BG_WHITE
      }
    },
    animationOptions: {
      animateIn: Animations.SLIDE_IN_RIGHT,
      animateOut: Animations.SLIDE_OUT_RIGHT,
      speed: 5
    }
  });
};
